import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { plusIcon } from './icons/plus-icon';
import { minusIcon } from './icons/minus-icon';
import { modifyToValidValue } from './helpers';
import type { TIncreaseDecreaseInput } from './models';

export const IncreaseDecreaseInput: FC<TIncreaseDecreaseInput> = ({
    Input,
    InputComponent = Input,
    className,
    max,
    min,
    name = '',
    onDecrease,
    onIncrease,
    paddingleft = '48px',
    styles,
    value = '',
    onClick = () => {},
    ...rest
}) => {
    // TODO поисследовать, можем ли обойтись без getNumbersFromStr (ALFABANKRU-38816)
    const validValue = modifyToValidValue(value);

    return (
        <div className={cn(styles.inputWrapper)}>
            {onDecrease && (
                <button
                    className={cn(styles.button, styles.minusButton)}
                    disabled={validValue <= min}
                    id={`decrease-input-button${name}`}
                    onClick={(...onDecreaseRest) => {
                        onDecrease(...onDecreaseRest);
                        onClick();
                    }}
                    type="button"
                >
                    {minusIcon}
                </button>
            )}
            <InputComponent
                {...rest}
                className={className}
                name={name}
                onClick={onClick}
                paddingleft={paddingleft}
                value={value}
            />
            {onIncrease && (
                <button
                    className={cn(styles.button, styles.plusButton)}
                    disabled={validValue >= max}
                    id={`increase-input-button${name}`}
                    onClick={(...onIncreaseRest) => {
                        onIncrease(...onIncreaseRest);
                        onClick();
                    }}
                    type="button"
                >
                    {plusIcon}
                </button>
            )}
        </div>
    );
};
